// extracted by mini-css-extract-plugin
module.exports = {"items":"Section5_items__1a2U8","item":"Section5_item__1yKH1","title":"Section5_title__3QzvJ","description":"Section5_description__1L4ST","features":"Section5_features__1HWDC"};